// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page header */
.my-people-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.25rem;
}

.my-people-title {
  margin: 0;
}

.my-people-subtitle {
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

/* Grid — single column on mobile, 2-up at md, 3-up at xl */
.people-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  align-items: start;
  gap: 0.75rem;
}

/* Card shell */
.person-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--bs-border-color, #d0d7de);
  border-radius: 0.35rem;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  overflow: hidden;
}

.person-card--expanded {
  grid-column: 1 / -1;
  border-color: var(--sms-blue-light, #4a82bb);
  box-shadow: 0 2px 10px rgba(52, 100, 152, 0.12);
}

/* Header band */
.person-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.55rem 0.65rem 0.45rem 0.75rem;
  background: var(--sms-gray-light, #f4f4f4);
  border-bottom: 1px solid var(--bs-border-color, #d0d7de);
}

.person-card__name {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--sms-blue, #346498);
  line-height: 1.2;
  flex: 1;
}

/* Action buttons */
.person-card__actions {
  display: flex;
  gap: 0.2rem;
  flex-shrink: 0;
}

.person-card__action-btn {
  padding: 0.2rem 0.45rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: var(--sms-gray-mid, #888);
  background: transparent;
  font-size: 0.8rem;
  line-height: 1;
  transition: color 0.12s, background-color 0.12s, border-color 0.12s;
}

.person-card__action-btn:hover {
  color: var(--sms-blue, #346498);
  background: var(--sms-blue-muted, #d6e4f0);
  border-color: var(--sms-blue-light, #4a82bb);
}

.person-card__action-btn.active {
  color: #fff;
  background: var(--sms-blue, #346498);
  border-color: var(--sms-blue, #346498);
}

.person-card__action-btn--danger:hover {
  color: #fff;
  background: #dc3545;
  border-color: #dc3545;
}

/* Body */
.person-card__body {
  flex: 1;
  padding: 0.6rem 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Attribute row */
.person-card__attr-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem 1rem;
}

.person-card__attr {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.person-card__attr-label {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sms-gray-mid, #888);
}

.person-card__attr-value {
  font-size: 0.85rem;
  color: #2c2c2c;
}

/* Registration ID pills */
.person-card__ids {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.person-card__id-badge {
  display: inline-flex;
  align-items: baseline;
  gap: 0.2rem;
  padding: 0.15rem 0.45rem;
  border: 1px solid var(--bs-border-color, #d0d7de);
  border-radius: 1rem;
  font-size: 0.75rem;
  color: #2c2c2c;
  background: #fff;
  white-space: nowrap;
}

.person-card__id-org {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-weight: 700;
  font-size: 0.62rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--sms-gray-mid, #888);
}

/* Inline view/edit panel */
.person-card__panel {
  border-top: 1px solid var(--bs-border-color, #d0d7de);
  padding: 0.75rem;
  background: #f9fbfd;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/people/my-people/my-people.component.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,4DAA4D;EAC5D,kBAAkB;EAClB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,sBAAsB;EACtB,gBAAgB;EAChB,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,wCAAwC;EACxC,0CAA0C;EAC1C,wDAAwD;AAC1D;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,OAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mEAAmE;AACrE;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Page header */\n.my-people-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.25rem;\n}\n\n.my-people-title {\n  margin: 0;\n}\n\n.my-people-subtitle {\n  font-size: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n/* Grid — single column on mobile, 2-up at md, 3-up at xl */\n.people-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  align-items: start;\n  gap: 0.75rem;\n}\n\n/* Card shell */\n.person-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--bs-border-color, #d0d7de);\n  border-radius: 0.35rem;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  overflow: hidden;\n}\n\n.person-card--expanded {\n  grid-column: 1 / -1;\n  border-color: var(--sms-blue-light, #4a82bb);\n  box-shadow: 0 2px 10px rgba(52, 100, 152, 0.12);\n}\n\n/* Header band */\n.person-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.55rem 0.65rem 0.45rem 0.75rem;\n  background: var(--sms-gray-light, #f4f4f4);\n  border-bottom: 1px solid var(--bs-border-color, #d0d7de);\n}\n\n.person-card__name {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-weight: 700;\n  font-size: 1rem;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--sms-blue, #346498);\n  line-height: 1.2;\n  flex: 1;\n}\n\n/* Action buttons */\n.person-card__actions {\n  display: flex;\n  gap: 0.2rem;\n  flex-shrink: 0;\n}\n\n.person-card__action-btn {\n  padding: 0.2rem 0.45rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  color: var(--sms-gray-mid, #888);\n  background: transparent;\n  font-size: 0.8rem;\n  line-height: 1;\n  transition: color 0.12s, background-color 0.12s, border-color 0.12s;\n}\n\n.person-card__action-btn:hover {\n  color: var(--sms-blue, #346498);\n  background: var(--sms-blue-muted, #d6e4f0);\n  border-color: var(--sms-blue-light, #4a82bb);\n}\n\n.person-card__action-btn.active {\n  color: #fff;\n  background: var(--sms-blue, #346498);\n  border-color: var(--sms-blue, #346498);\n}\n\n.person-card__action-btn--danger:hover {\n  color: #fff;\n  background: #dc3545;\n  border-color: #dc3545;\n}\n\n/* Body */\n.person-card__body {\n  flex: 1;\n  padding: 0.6rem 0.75rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* Attribute row */\n.person-card__attr-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem 1rem;\n}\n\n.person-card__attr {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n}\n\n.person-card__attr-label {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--sms-gray-mid, #888);\n}\n\n.person-card__attr-value {\n  font-size: 0.85rem;\n  color: #2c2c2c;\n}\n\n/* Registration ID pills */\n.person-card__ids {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.person-card__id-badge {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.2rem;\n  padding: 0.15rem 0.45rem;\n  border: 1px solid var(--bs-border-color, #d0d7de);\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  color: #2c2c2c;\n  background: #fff;\n  white-space: nowrap;\n}\n\n.person-card__id-org {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-weight: 700;\n  font-size: 0.62rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--sms-gray-mid, #888);\n}\n\n/* Inline view/edit panel */\n.person-card__panel {\n  border-top: 1px solid var(--bs-border-color, #d0d7de);\n  padding: 0.75rem;\n  background: #f9fbfd;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
